/* Every launch module can be edited, hidden, or reordered independently. */
function mountF1Draft(root) {
  const q = selector => root.querySelector(selector);
  const qa = selector => Array.from(root.querySelectorAll(selector));
  const cleanup = [];
  const on = (element, type, handler, options) => {
    if (!element) return;
    element.addEventListener(type, handler, options);
    cleanup.push(() => element.removeEventListener(type, handler, options));
  };
  const targets = new Map(qa('[id]').map(element => [element.id, element]));
  const targetFor = hash => {
    if (!hash || hash.length < 2) return null;
    try { return targets.get(decodeURIComponent(hash.slice(1))) || null; }
    catch (_) { return null; }
  };
  const menu = q('.menu-panel'), toggle = q('.menu-toggle');
  const openLabel = toggle && (toggle.dataset.labelOpen || toggle.dataset.openLabel || toggle.getAttribute('aria-label'));
  const closeLabel = toggle && (toggle.dataset.labelClose || toggle.dataset.closeLabel || 'Close page menu');
  function closeMenu() {
    if (menu) menu.hidden = true;
    if (toggle) { toggle.setAttribute('aria-expanded', 'false'); toggle.setAttribute('aria-label', openLabel || 'Open page menu'); }
  }
  if (menu && toggle) {
    on(toggle, 'click', () => {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      menu.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? closeLabel : openLabel);
    });
    on(root, 'keydown', event => { if (event.key === 'Escape' && !menu.hidden) { closeMenu(); toggle.focus(); } });
  }
  qa('.floating-header a[href^="#"],.menu-panel a[href^="#"]').forEach(link => {
    const previous = link.hidden;
    if (!targetFor(link.getAttribute('href'))) link.hidden = true;
    cleanup.push(() => { link.hidden = previous; });
  });
  if (toggle && menu) {
    const previous = toggle.hidden;
    if (!Array.from(menu.querySelectorAll('a')).some(link => !link.hidden)) toggle.hidden = true;
    cleanup.push(() => { toggle.hidden = previous; });
  }
  qa('a[href^="#"]').forEach(link => on(link, 'click', event => {
    const target = targetFor(link.getAttribute('href'));
    if (!target) return;
    event.preventDefault();
    closeMenu();
    target.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
  }));

  function selectGalleryImage(button) {
    if (!button) return;
    const gallery = button.closest('.product-gallery');
    const image = gallery && gallery.querySelector('[data-gallery-main]');
    const url = button.dataset.imageUrl;
    if (!image || !url) return;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = url;
    image.alt = button.dataset.imageAlt || '';
    gallery.querySelectorAll('[data-gallery-image]').forEach(item => {
      const selected = item === button;
      item.classList.toggle('selected', selected);
      item.setAttribute('aria-pressed', String(selected));
    });
  }
  qa('[data-gallery-image]').forEach(button => on(button, 'click', () => selectGalleryImage(button)));

  /* Native product forms retain Shopify's price and availability on first load. */
  qa('.native-product-form').forEach(form => {
    const picker = form.querySelector('[data-native-variant]');
    const submit = form.querySelector('[data-native-submit]');
    const card = form.closest('.purchase-card') || form;
    const price = card.querySelector('[data-price]');
    const notice = card.querySelector('.native-purchase-notice');
    const accelerated = form.querySelector('.native-checkout-buttons');
    if (!picker || !submit) return;
    on(picker, 'change', () => {
      const option = picker.selectedOptions[0];
      const published = !!option && option.dataset.published === 'true';
      const available = !!option && option.dataset.available === 'true';
      const state = !published ? 'draft' : available ? 'available' : 'unavailable';
      submit.disabled = !(published && available);
      if (option && price && option.dataset.price) price.textContent = option.dataset.price;
      const label = submit.querySelector('[data-native-submit-label]') || submit.querySelector('span');
      if (label && form.dataset[state + 'Label']) label.textContent = form.dataset[state + 'Label'];
      if (notice && form.dataset[state + 'Notice']) notice.textContent = form.dataset[state + 'Notice'];
      if (accelerated) accelerated.hidden = !(published && available);
    });
  });

  const floating = q('.floating-order');
  if (floating) {
    const order = q('.order-grid');
    const target = targetFor(floating.getAttribute('href'));
    const scenes = [q('.hero'), q('.release-intro'), order].filter(Boolean);
    if (!order || !target) floating.hidden = true;
    else if (typeof IntersectionObserver === 'function') {
      const visible = new Map(scenes.map(scene => [scene, true]));
      let active = true;
      const observer = new IntersectionObserver(entries => {
        if (!active) return;
        entries.forEach(entry => visible.set(entry.target, entry.isIntersecting));
        floating.hidden = Array.from(visible.values()).some(Boolean);
      }, {threshold: .01});
      scenes.forEach(scene => observer.observe(scene));
      cleanup.push(() => { active = false; observer.disconnect(); });
    } else floating.hidden = true;
  }
  const faqMotion = mountFAQMotion(root);
  cleanup.push(faqMotion);
  cleanup.push(mountScrollMotion(root));
  function revealSelected(target) {
    if (!target || !root.contains(target)) return;
    const details = target.matches('.faq-list details') ? target : target.closest('.faq-list details');
    if (details) faqMotion.open(details);
    const galleryButton = target.matches('[data-gallery-image]') ? target : target.querySelector('[data-gallery-image]');
    if (galleryButton) selectGalleryImage(galleryButton);
    const selected = details || target;
    const reveal = element => {
      if (element.matches('[data-scroll-reveal]')) element.classList.add('is-revealed');
      if (element.matches('[data-heading-reveal]')) element.classList.add('is-heading-revealed');
    };
    reveal(selected);
    selected.querySelectorAll('[data-scroll-reveal],[data-heading-reveal]').forEach(reveal);
    const ancestor = selected.closest('[data-scroll-reveal]');
    if (ancestor) ancestor.classList.add('is-revealed');
    selected.scrollIntoView({behavior: 'auto', block: 'center'});
  }
  const destroy = () => cleanup.reverse().forEach(fn => fn());
  destroy.select = revealSelected;
  return destroy;
}

function mountFAQMotion(root) {
  const media = window.matchMedia('(prefers-reduced-motion: reduce)');
  const items = new Map();
  root.querySelectorAll('.faq-list details').forEach(details => {
    const summary = details.querySelector('summary'), panel = details.querySelector('.faq-answer');
    if (!summary || !panel) return;
    let targetOpen = details.open, animation = null;
    function settle() {
      const current = animation;
      animation = null;
      details.open = targetOpen;
      details.classList.toggle('is-expanded', targetOpen);
      details.classList.remove('is-animating');
      if (current) { current.onfinish = null; current.cancel(); }
    }
    function toggle(event) {
      event.preventDefault();
      const height = details.open ? panel.getBoundingClientRect().height : 0;
      const opacity = details.open ? Number(getComputedStyle(panel).opacity) : 0;
      const previous = animation;
      animation = null;
      if (previous) { previous.onfinish = null; previous.cancel(); }
      targetOpen = !targetOpen;
      details.classList.toggle('is-expanded', targetOpen);
      if (media.matches || typeof panel.animate !== 'function') { settle(); return; }
      details.open = true;
      details.classList.add('is-animating');
      animation = panel.animate([
        {height: `${height}px`, opacity},
        {height: `${targetOpen ? panel.scrollHeight : 0}px`, opacity: targetOpen ? 1 : 0}
      ], {duration: targetOpen ? 360 : 280, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'forwards'});
      animation.onfinish = settle;
    }
    function syncNative() {
      if (animation) return;
      targetOpen = details.open;
      details.classList.toggle('is-expanded', targetOpen);
    }
    summary.addEventListener('click', toggle);
    details.addEventListener('toggle', syncNative);
    items.set(details, {
      settle,
      open() { targetOpen = true; settle(); },
      destroy() {
        summary.removeEventListener('click', toggle);
        details.removeEventListener('toggle', syncNative);
        settle(); details.classList.remove('is-expanded');
      }
    });
  });
  function reduce() { if (media.matches) items.forEach(item => item.settle()); }
  media.addEventListener('change', reduce);
  const destroy = () => { media.removeEventListener('change', reduce); items.forEach(item => item.destroy()); };
  destroy.open = details => { const item = items.get(details); if (item) item.open(); };
  return destroy;
}

function mountScrollMotion(root) {
  const page = root;
  const media = window.matchMedia('(prefers-reduced-motion: reduce)');
  const control = page.querySelector('[data-launch-motion]');
  const enabled = !control || control.getAttribute('data-launch-motion') !== 'false';
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  const revealTargets = Array.from(page.querySelectorAll('.hero-title,.intro,.finish-panel,.feature-copy,.dark-photo,.detail-tile,.edition-break,.order-heading,.purchase-card,.faq-list'));
  const headingTargets = Array.from(page.querySelectorAll('h2'));
  const photos = Array.from(page.querySelectorAll('.hero-visual,.finish-panel,.dark-photo,.tile-media')).map(scene => ({scene, image: scene.querySelector('img')})).filter(item => item.image);
  const paragraphs = Array.from(page.querySelectorAll('.intro p')).map(element => {
    const original = element.innerHTML;
    Array.from(element.childNodes).forEach(node => {
      if (node.nodeType !== Node.TEXT_NODE) return;
      const fragment = document.createDocumentFragment();
      node.textContent.split(/(\s+)/).forEach(part => {
        if (!part) return;
        if (/^\s+$/.test(part)) fragment.appendChild(document.createTextNode(part));
        else { const word = document.createElement('span'); word.className = 'scroll-word'; word.textContent = part; fragment.appendChild(word); }
      });
      node.replaceWith(fragment);
    });
    return {element, original, words: Array.from(element.querySelectorAll('.scroll-word'))};
  });
  const introWords = paragraphs.flatMap(item => item.words);
  let observer = null, headingObserver = null, frame = 0, running = false;
  page.classList.toggle('motion-disabled', !enabled);
  revealTargets.forEach(element => element.setAttribute('data-scroll-reveal', ''));
  headingTargets.forEach(element => element.setAttribute('data-heading-reveal', ''));
  photos.forEach(item => item.image.classList.add('scroll-photo'));
  function paint() {
    frame = 0;
    if (!running) return;
    const height = window.innerHeight, distance = window.innerWidth < 651 ? 9 : 15;
    const hero = page.querySelector('.hero');
    page.classList.toggle('has-scrolled', hero ? hero.getBoundingClientRect().top < -70 : window.scrollY > 70);
    photos.forEach(({scene, image}) => {
      const rect = scene.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > height) return;
      const progress = clamp((height - rect.top) / (height + rect.height), 0, 1);
      image.style.setProperty('--scroll-y', `${((progress - .5) * distance * 2).toFixed(2)}px`);
      image.style.setProperty('--scroll-scale', (1.085 - progress * .035).toFixed(4));
    });
    if (paragraphs.length) {
      const top = paragraphs[0].element.getBoundingClientRect().top;
      const bottom = paragraphs[paragraphs.length - 1].element.getBoundingClientRect().bottom;
      if (bottom >= 0 && top <= height) {
        const progress = clamp((height * .82 - top) / (height * .5 + (bottom - top) * .5), 0, 1);
        introWords.forEach((word, index) => word.style.setProperty('--word-opacity', clamp(progress * (introWords.length + 1) - index, .18, 1).toFixed(3)));
      }
    }
  }
  function schedule() { if (running && !frame) frame = requestAnimationFrame(paint); }
  function stop() {
    running = false;
    if (frame) cancelAnimationFrame(frame);
    frame = 0;
    if (observer) observer.disconnect();
    observer = null;
    if (headingObserver) headingObserver.disconnect();
    headingObserver = null;
    document.removeEventListener('scroll', schedule, true);
    window.removeEventListener('resize', schedule);
    window.removeEventListener('load', schedule);
    photos.forEach(item => item.image.removeEventListener('load', schedule));
    page.classList.remove('motion-ready', 'has-scrolled');
    photos.forEach(({image}) => { image.style.removeProperty('--scroll-y'); image.style.removeProperty('--scroll-scale'); });
    paragraphs.forEach(item => item.words.forEach(word => word.style.removeProperty('--word-opacity')));
  }
  function configure() {
    stop();
    if (!enabled || media.matches || typeof IntersectionObserver !== 'function') return;
    running = true;
    revealTargets.forEach(element => {
      const rect = element.getBoundingClientRect();
      element.classList.toggle('is-revealed', rect.bottom > 0 && rect.top < window.innerHeight * .94);
    });
    headingTargets.forEach(element => element.classList.remove('is-heading-revealed'));
    page.classList.add('motion-ready');
    observer = new IntersectionObserver((entries, activeObserver) => {
      if (!running || activeObserver !== observer) return;
      entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-revealed'); activeObserver.unobserve(entry.target); } });
    }, {threshold: .06, rootMargin: '0px 0px -5% 0px'});
    revealTargets.forEach(element => { if (!element.classList.contains('is-revealed')) observer.observe(element); });
    headingObserver = new IntersectionObserver((entries, activeObserver) => {
      if (!running || activeObserver !== headingObserver) return;
      entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-heading-revealed'); activeObserver.unobserve(entry.target); } });
    }, {threshold: .15, rootMargin: '0px 0px -5% 0px'});
    headingTargets.forEach(element => headingObserver.observe(element));
    document.addEventListener('scroll', schedule, {passive: true, capture: true});
    window.addEventListener('resize', schedule, {passive: true});
    window.addEventListener('load', schedule, {passive: true});
    photos.forEach(({image}) => {
      image.addEventListener('load', schedule);
      if (image.complete && typeof image.decode === 'function') image.decode().then(schedule, () => {});
    });
    schedule();
  }
  function revealFocus(event) {
    const selected = event.target.closest('[data-scroll-reveal]');
    if (selected) selected.classList.add('is-revealed');
    const heading = event.target.closest('[data-heading-reveal]');
    if (heading) { heading.classList.add('is-heading-revealed'); if (headingObserver) headingObserver.unobserve(heading); }
  }
  page.addEventListener('focusin', revealFocus);
  media.addEventListener('change', configure);
  configure();
  return () => {
    stop();
    media.removeEventListener('change', configure);
    page.removeEventListener('focusin', revealFocus);
    page.classList.remove('motion-disabled');
    revealTargets.forEach(element => { element.removeAttribute('data-scroll-reveal'); element.classList.remove('is-revealed'); });
    headingTargets.forEach(element => { element.removeAttribute('data-heading-reveal'); element.classList.remove('is-heading-revealed'); });
    photos.forEach(({image}) => image.classList.remove('scroll-photo'));
    paragraphs.forEach(({element, original}) => { element.innerHTML = original; });
  };
}

/* Shopify replaces section nodes while the shared page wrapper stays in place. */
(function () {
  let mounted = null, frame = 0;
  function mount() {
    frame = 0;
    if (mounted) mounted();
    mounted = null;
    const root = document.querySelector('[data-gh60-launch]');
    if (root) mounted = mountF1Draft(root);
  }
  function scheduleMount() {
    if (mounted) mounted();
    mounted = null;
    if (!frame) frame = requestAnimationFrame(mount);
  }
  function select(event) {
    if (frame) { cancelAnimationFrame(frame); frame = 0; mount(); }
    if (mounted && mounted.select) mounted.select(event.target);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, {once: true});
  else mount();
  document.addEventListener('shopify:section:load', scheduleMount);
  document.addEventListener('shopify:section:unload', scheduleMount);
  document.addEventListener('shopify:section:reorder', scheduleMount);
  document.addEventListener('shopify:section:select', select);
  document.addEventListener('shopify:block:select', select);
})();
